import { render } from "./PanelRutas.vue?vue&type=template&id=64f7da8f&scoped=true"
import script from "./PanelRutas.vue?vue&type=script&lang=js"
export * from "./PanelRutas.vue?vue&type=script&lang=js"

import "./PanelRutas.vue?vue&type=style&index=0&id=64f7da8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f7da8f"]])

export default __exports__